webpackJsonp([193347859872124],{

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border: 1px solid ', ';\n  border-radius: 3px;  \n  padding-left: 0.5em;  \n  padding-right: 0.5em;  \n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n  font-size: 2rem;\n  margin-bottom: 0.25em;\n  margin-right: 0.25em;  \n  margin-top: 0;\n  color: ', ';\n  display: inline-block;\n  transition: all .3s ease;\n  height: 5rem;  \n  &:hover {\n    color: ', ';\n    background: ', ';\n  }  \n'], ['\n  border: 1px solid ', ';\n  border-radius: 3px;  \n  padding-left: 0.5em;  \n  padding-right: 0.5em;  \n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n  font-size: 2rem;\n  margin-bottom: 0.25em;\n  margin-right: 0.25em;  \n  margin-top: 0;\n  color: ', ';\n  display: inline-block;\n  transition: all .3s ease;\n  height: 5rem;  \n  &:hover {\n    color: ', ';\n    background: ', ';\n  }  \n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ctaButton = function (_Component) {
	  _inherits(ctaButton, _Component);
	
	  function ctaButton() {
	    _classCallCheck(this, ctaButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ctaButton.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { style: { border: 'none' }, to: this.props.to },
	      _react2.default.createElement(
	        ButtonContainer,
	        null,
	        children
	      )
	    );
	  };
	
	  return ctaButton;
	}(_react.Component);
	
	exports.default = ctaButton;
	
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.accent;
	}, function (props) {
	  return props.theme.brand;
	});
	module.exports = exports['default'];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO,
	        language = _props.language;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === '/' ? '' : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      '@context': 'http://schema.org',
	      '@type': 'WebSite',
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt[language] : ''
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            '@id': postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        '@context': 'http://schema.org',
	        '@type': 'BlogPosting',
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt['en_uk'] : '',
	        headline: title,
	        image: {
	          '@type': 'ImageObject',
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', {
	        property: 'fb:app_id',
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:creator',
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style-type: \'\u2714 \';       \n  li { \n    padding-right: 25px;\n  }\n'], ['\n  list-style-type: \'\u2714 \';       \n  li { \n    padding-right: 25px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: ', ';  \n  background: ', ';    \n'], ['\n  padding: ', ';  \n  background: ', ';    \n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\npadding: ', ';  \npadding-bottom: 16rem;\n'], ['\npadding: ', ';  \npadding-bottom: 16rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nmargin: 0 auto;\nmax-width: ', ';\ncolor:  ', ';\n'], ['\nmargin: 0 auto;\nmax-width: ', ';\ncolor:  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\nmargin: 0 auto;\nmax-width: ', ';\n'], ['\nmargin: 0 auto;\nmax-width: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(48);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _CtaButton = __webpack_require__(88);
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      'div',
	      { className: 'index-container' },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { postEdges: postEdges, language: 'ko_kr' }),
	      _react2.default.createElement(
	        'main',
	        { style: { display: 'flex', flexDirection: 'column' } },
	        _react2.default.createElement(
	          'span',
	          { style: { flex: 1, minHeight: '65vh' } },
	          _react2.default.createElement(_Header2.default, {
	            isMain: true,
	            siteTitleAlt: _SiteConfig2.default.siteTitleAlt.ko_kr,
	            siteTitle: _SiteConfig2.default.siteTitle,
	            siteDescription: _SiteConfig2.default.siteDescription,
	            location: this.props.location,
	            logo: _SiteConfig2.default.siteLogo,
	            language: 'ko_kr'
	          })
	        ),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            BodyContents,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Nact\uB294 \uB9D0\uD558\uC790\uBA74, \uC11C\uBC84\uC5D0\uC11C \uC2E4\uD589\uB418\uB294 Redux\uB77C\uACE0 \uC0DD\uAC01\uD558\uC2DC\uBA74 \uB429\uB2C8\uB2E4'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\uC624\uB298\uB0A0\uC758 \uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uC11C\uBC84\uB294 10\uB144 \uC804\uACFC \uB9CE\uC774 \uB2E4\uB985\uB2C8\uB2E4. \uADF8\uB7F0\uB370 \uC65C \uC6B0\uB9AC\uB294 \uC5EC\uC804\uD788 90\uB144\uB300 \uC2A4\uD0C0\uC77C\uB85C \uD504\uB85C\uADF8\uB798\uBC0D\uC744 \uD558\uACE0 \uC788\uC744\uAE4C\uC694?'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nact\uB294 Akka\uC640 Erlang\uC5D0\uC11C \uC601\uAC10\uC744 \uBC1B\uC558\uC2B5\uB2C8\uB2E4.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nact\uB294 \uC624\uD508\uC18C\uC2A4 Node.js \uD504\uB808\uC784\uC6CC\uD06C\uB85C\uC11C, \uC544\uB798\uC640 \uAC19\uC740 \uAC83\uB4E4\uC744 \uC5EC\uB7EC\uBD84\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C \uAC00\uB2A5\uD558\uAC8C \uD574\uC90D\uB2C8\uB2E4.'
	            ),
	            _react2.default.createElement(
	              BenefitsList,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                '\uD6A8\uC728\uC801\uC778 \uBA54\uBAA8\uB9AC \uC0AC\uC6A9'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                '\uD0C4\uB825\uC131(resilience), \uB0B4\uACB0\uD568\uC131 \uD5A5\uC0C1'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                '\uC131\uB2A5 \uD5A5\uC0C1'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                '\uBAA8\uB4C8\uAC04\uC758 \uC758\uC874 \uACB0\uD569 \uD574\uC18C(\uB514\uCEE4\uD50C\uB9C1)'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nact\uB294 \uAC04\uD3B8\uD55C \uC774\uBCA4\uD2B8 \uC18C\uC2F1 \uC9C0\uC6D0\uACFC \uC798 \uC124\uACC4\uB41C \uC561\uD130 \uBAA8\uB378 \uAD6C\uD604\uC744 \uC81C\uACF5\uD568\uC73C\uB85C\uC368 \uB2E4\uC591\uD55C \uC601\uC5ED\uC5D0\uC11C \uD65C\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nact\uAC00 \uBE44\uB85D \uB9CC\uB2A5\uC740 \uC544\uB2D9\uB2C8\uB2E4. \uD558\uC9C0\uB9CC \uB2E4\uC591\uD55C \uC694\uAD6C \uC0AC\uB840\uB4E4\uC744 \uD574\uACB0\uD558\uAE30 \uC704\uD574 \uC131\uC7A5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\uC5EC\uB7EC\uBD84\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C\uB3C4 \uC0AC\uC6A9\uD574 \uBCFC \uB9CC\uD55C \uBD80\uBD84\uC774 \uC788\uACA0\uC9C0\uC694?'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          BodyContainerInverted,
	          null,
	          _react2.default.createElement(
	            BodyContentsInverted,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              '\uC2DC\uC791\uD558\uAE30'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nact\uB294 ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://reasonml.github.io/', 'data-jzz-gui-player': 'true' },
	                'ReasonML'
	              ),
	              '\uACFC JavaScript \uB77C\uC774\uBE0C\uB7EC\uB9AC\uB85C \uC81C\uACF5\uB429\uB2C8\uB2E4. \uB450 \uAC00\uC9C0 \uBAA8\uB450 100% \uD14C\uC2A4\uD2B8 \uCEE4\uBC84\uB9AC\uC9C0\uC640 \uC644\uBCBD\uD55C \uBB38\uC11C\uB97C \uC81C\uACF5\uD558\uACE0, \uD504\uB85C\uC81D\uD2B8 \uBA54\uC778\uD14C\uC774\uB108\uC758 \uC9C0\uC6D0 \uD558\uC5D0 \uAD00\uB9AC\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nact \uD504\uB808\uC784\uC6CC\uD06C\uC758 \uC804\uBC18\uC801\uC778 \uB0B4\uC6A9\uC744 \uD558\uB8E8\uC544\uCE68\uC5D0 \uD559\uC2B5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uD2B9\uD788 ',
	              _react2.default.createElement(
	                'code',
	                { 'class': 'highlighter-rouge' },
	                'Hello World'
	              ),
	              ' \uC608\uC81C\uB97C \uC2E4\uC2B5\uD558\uB294\uB370\uB294 15\uBD84\uB3C4 \uC548 \uAC78\uB9BD\uB2C8\uB2E4.'
	            ),
	            _react2.default.createElement(
	              _CtaButton2.default,
	              { to: '/ko_kr/lesson/javascript/nact-%EC%86%8C%EA%B0%9C' },
	              _react2.default.createElement('img', { style: { height: '2.5rem' }, src: '/logos/language-logo_js-inverted.svg' }),
	              ' JAVASCRIPT'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	
	
	var BenefitsList = _styledComponents2.default.ul(_templateObject);
	
	var BodyContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.brand;
	});
	
	var BodyContainerInverted = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.sitePadding;
	});
	
	var BodyContents = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.accent;
	});
	
	var BodyContentsInverted = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.theme.contentWidthLaptop;
	});
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ko-kr-jsx-7e5c460fc6bb8cd66122.js